import { Dispatch, useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledTextField } from 'components/shared/ControlledFields';

import { Box } from '@mui/material';
import { PRIMARY } from 'constants/colors';

export interface Filters {
  search: string | null;
}

interface FilterForm extends Filters {
  search: string | null;
}

interface Props {
  handleFilterChange: Dispatch<any>;
  dependencies?: any[];
  timeHighlight?: boolean;
}

const defaultValues = {
  search: null
};

export const FilterComponent = ({
  handleFilterChange,
  dependencies = [],
  timeHighlight = false
}: Props) => {
  const { t } = useTranslation('common');
  const { control, watch } = useForm<FilterForm>({
    defaultValues: defaultValues
  });

  const [filters, setFilters] = useState<Filters>(defaultValues);
  const search = watch('search');

  const updateFilter = (value, propName) => {
    setFilters((prev) => ({ ...prev, [propName]: value }));
  };

  useEffect(() => {
    updateFilter(search ?? null, 'search');
  }, [search, ...dependencies]);

  useEffect(() => {
    handleFilterChange(filters);
  }, [filters, ...dependencies]);

  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={{ flexGrow: 1, m: 1, maxWidth: '300px' }}>
        <ControlledTextField
          control={control}
          name="search"
          label={t('search')}
          {...(timeHighlight && {
            sx: {
              input: {
                color: PRIMARY
              }
            }
          })}
        />
      </Box>
    </Box>
  );
};
